import { ROLES } from "app/constants";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { LayoutRouter } from "common";
import {
  loadDictionaryAsync,
  selectDictionary,
} from "features/dictionaries/dictionarySlice";
import { selectAccessToken } from "features/identity/identitySlice";
import { selectProfile } from "features/profile/profileSlice";
import useAccess from "features/profile/useAccess";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AdminRouter from "routers/AdminRouter";
import PartnerRouter from "routers/PartnerRouter";
import PublicRouter from "routers/PublicRouter";

export default function App() {
  const access_token = useAppSelector(selectAccessToken);
  const profile = useAppSelector(selectProfile);
  const { pathname } = useLocation();
  const isSelfSeating =
    pathname === "/self-seating" || pathname.startsWith("/self-seating/");
  const dispatch = useAppDispatch();
  //useDocTitle(getMenu(true));
  const dictionaries = useAppSelector(selectDictionary);
  const { hasRoles } = useAccess();
  function getLayoutIndex() {
    if (access_token && profile.roles && hasRoles(ROLES.PARTNER)) {
      return 0;
    }
    if (access_token && profile.roles) {
      return 1;
    }
    return 2;
  }
  useEffect(() => {
    //if (Object.keys(dictionaries).length === 0) {
    if (access_token && !isSelfSeating) {
      dispatch(loadDictionaryAsync());
    }
    //}
  }, [access_token, isSelfSeating]);
  //TODO: Load profile on every page load for testing
  /*useEffect(() => {
    console.log("TWICE");
    dispatch(loadProfileAsync());
  }, []);*/
  if (isSelfSeating) {
    return <PublicRouter />;
  }

  return (
    <LayoutRouter getLayoutIndex={getLayoutIndex}>
      <PartnerRouter />
      <AdminRouter />
      <PublicRouter />
    </LayoutRouter>
  );
}
